import { render, staticRenderFns } from "./Notest.vue?vue&type=template&id=2947c1e1&style=height%3A%20100%25%3B"
import script from "./Notest.vue?vue&type=script&lang=js"
export * from "./Notest.vue?vue&type=script&lang=js"
import style0 from "./Notest.vue?vue&type=style&index=0&id=2947c1e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports